(function() {
	'use strict';
	angular.module('app')
		.filter('filtrobuscador', function() {
			return function(items, texto) {
				if (!texto) return items;
				texto = texto.toLowerCase();
				function contiene(valor) {
					if (!valor) return false;
					const res = valor.toString().toLowerCase().includes(texto);

					return res;
				}

				function productoCoincide(producto) {
					const camposProducto = [
						producto.title,
						producto.gen,
						producto.name
					];
				    
					if (camposProducto.some(contiene)) {

						return true;
					}

					if (Array.isArray(producto.skus_id)) {
						const matchSKU = producto.skus_id.some(sku => {
							return contiene(sku.sku) ;

						});
						if (matchSKU) return true;
					}

					return false;
				}


				angular.forEach(items, function(item, key) {
					const enRaiz = contiene(item.title);

					angular.forEach(item.products, function(p, pKey) {

						let enProductos = productoCoincide(p);

						if (enRaiz || enProductos) {
							items[key].products[pKey].hide = 0;
						} else {
							items[key].products[pKey].hide = 1;
						}
					})

				});

				return items;

			};
		});
})();
